import React, { useContext, useEffect, useState } from 'react';
import store from '../../store';
// Custom components 
import AppHeader from '../../components/AppHeader';
import CreateNewStory from '../../components/NewStoryModal';
// Material components
import {
    Container, Grid, Card, ListItemText, ListItem, List
} from '@material-ui/core';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { fonts } from '../../assets/jss'

const useStyles = makeStyles((theme) => ({
    gridItem: {
        marginBottom: 20
    },
    btn: {
        border: '1px solid white',
        color: 'white',
        marginBottom: 40
    },
    list: {
        padding: '8px 12px'
    }
}));

function Home() {
    const classes = useStyles();
    const { state, storyList, reducers } = useContext(store);
    const [myStories, setMyStories] = useState([])
    const [myContributions, setMyContributions] = useState([])

    useEffect(() => {
        setMyStories(storyList.filter(story => story.authorID === state.user.uid));
        setMyContributions(storyList.filter(story => story.contributors.includes(state.user.uid) && story.authorID !== state.user.uid));
        //eslint-disable-next-line
    }, [storyList, state.user.uid])

    const StoryList = ({ list }) => {
        return (
            <List className={classes.list}>
                {list.map((story, i) =>
                    <ListItem button key={i}
                        onClick={() => reducers.selectStory(story)}>
                        <ListItemText>{story.title}</ListItemText>
                    </ListItem>
                )}
            </List>
        )
    }

    return (
        <AppHeader>
            <Container>
                <h2 style={fonts.secondary}>My Stories</h2>
                <CreateNewStory />
                <Grid container justify='space-around'>
                    <Grid item xs={11} sm={10} md={5}
                        className={classes.gridItem}>
                        <Card>
                            <h4 style={fonts.secondary}>Stories I started</h4>
                            <StoryList list={myStories} />
                        </Card>
                    </Grid>
                    <Grid item xs={11} sm={10} md={5}
                        className={classes.gridItem}>
                        <Card>
                            <h4 style={fonts.secondary}>My Contributions</h4>
                            <StoryList list={myContributions} />
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </AppHeader>
    );
}

export default Home;
